import { z } from 'zod';
import { oneOf, str } from '../../navigation/searchParams';

/** The Agents list filters, and the agent editor (`id` is the agent's name). */
export const agentsSearch = z.object({
  q: str,
  channel: str,
  status: str,
  modal: oneOf(['create-agent', 'edit-agent', 'duplicate-agent']),
  id: str,
  mtab: str,
});
